<template>
  <div
    :style="{display: currentIndex!== index ? 'none': 'block'}"
    class="swiper-slide"
  >
    <div :class="['banner__item',{'swipe-right': right},{'swipe-left': left},{'swipe-active': currentIndex=== index}]">
      <slot />
    </div>
    <AppSwiperMobileLoader
      v-if="size > 1"
      :timer-seconds="timerSeconds"
    />
  </div>
</template>

<script setup>
import AppSwiperMobileLoader from '@/components/ui/AppSwiper/AppSwiperMobileLoader';

const props = defineProps({
  currentIndex: {
    type: Number
  },
  right: {
    type: Boolean
  },
  left: {
    type: Boolean
  },
  index: {
    type: Number
  },
  timerSeconds: {
    type: Number
  },
  size: {
    type: Number
  }
});
</script>

<style scoped>

.swiper-slide {
  display: inline-block;
  width: 100%;
}

.banner__item {
  transition-property: opacity, transform;
  transition-timing-function: ease;
  transition-duration: .5s;
}

.swipe-active {
  animation: previewSwipe .3s 1 ease;
}

.swipe-right {
  transform: translateX(-100px);
  opacity: 0;
}

.swipe-left {
  transform: translateX(100px);
  opacity: 0;
}

@keyframes previewSwipe {
  0%{
    opacity: 0;
    transform: scale(.95);
  }
  100%{
    opacity: 1;
    transform: scale(1);
  }
}

</style>
